let storage = {
  saveToken: function (token, user, roleId, group) {
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("username", user);
    sessionStorage.setItem("role", roleId);
    sessionStorage.setItem("group", group);

    const req = indexedDB.open("authDB", 1);
    req.onupgradeneeded = (evt) => {
      const db = evt.target.result;
      if (!db.objectStoreNames.contains("tokens")) {
        db.createObjectStore("tokens");
      }
    };
    req.onsuccess = (evt) => {
      const db = evt.target.result;
      const tx = db.transaction("tokens", "readwrite");
      tx.objectStore("tokens").put(token, "jwt");
      tx.oncomplete = () => db.close();
      tx.onerror = () => console.error("IDB: fallo al guardar token");
    };
    req.onerror = () => {
      console.error("IDB: no se pudo abrir la base de datos");
    };
  },

  saveTokenFromOAuth2: function (userInfo) {
    this.saveToken(
      userInfo.raw.accessToken,
      userInfo.name,
      userInfo.role,
      userInfo.allRoles[0] || ""
    );
  },

  saveSwStatus: function (status) {
    localStorage.setItem("sw-registered", status);
  },

  loadSwStatus: function () {
    return localStorage.getItem("sw-registered");
  },

  loadToken: function () {
    const data = sessionStorage.getItem("token");
    return data;
  },

  loadUsername: function () {
    const data = sessionStorage.getItem("username");
    return data;
  },

  loadIsRole: function () {
    const data = sessionStorage.getItem("role");
    return data;
  },

  loadGroup: function () {
    const data = sessionStorage.getItem("group");
    return data;
  },

  loadAuthenticated: function () {
    const data = sessionStorage.getItem("isAuthenticated");
    return data;
  },

  saveAuthenticated: function (value) {
    sessionStorage.setItem("isAuthenticated", value);
  },

  removeItemsSessionStorage: function () {
    sessionStorage.clear();
  },

  saveInfoFilter: function (filters) {
    const key = "orderFilters";
    const payload = {
      timestamp: new Date().toISOString(),
      filters,
    };
    localStorage.setItem(key, JSON.stringify(payload));
  },

  loadInfoFilter: function () {
    const key = "orderFilters";
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    try {
      const { timestamp, filters } = JSON.parse(raw);
      const then = new Date(timestamp);
      const now = new Date();
      const hoursElapsed = (now - then) / (1000 * 60 * 60);

      if (hoursElapsed > 12) {
        localStorage.removeItem(key);
        return null;
      }

      return filters;
    } catch {
      localStorage.removeItem(key);
      return null;
    }
  },
};

export default storage;
